import { render, staticRenderFns } from "./SmartTooltipBase.vue?vue&type=template&id=04b45f3c&scoped=true&"
import script from "./SmartTooltipBase.vue?vue&type=script&lang=js&"
export * from "./SmartTooltipBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b45f3c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VMenu})
